import theme from '@styles/theme';
export default {
  section: (bg: string) => ({
    position: 'relative',
    bg,
    zIndex: theme.zIndex.documentUp,
    width: '100%',
    padding: [theme.grids.container.padding.mobileBigMargin, theme.grids.container.padding.mobileBigMargin, theme.grids.container.padding.tabletSmallMargin, theme.grids.container.padding.tabletSmallMargin, theme.grids.container.padding.desktop],
    ...theme.grids.mainGrid
  }),
  content: {
    gridColumn: ['span 5', 'span 5', 'span 6', 'span 6', '2 / span 10']
  },
  heading: {
    pt: ['64px', '64px', '128 px', '128px', '208px'],
    pl: [0, 0, '40px', '40px', 0]
  }
};